// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

const isAppSettingsCustomEventsDataObject = objectOf({
  name: string,
  blacklisted: boolean,
  known: maybe(boolean, true),
  included_in_analytics_report: boolean,
});

export const isAppSettingsCustomEventsDataResult = objectOf({
  hits: number,
  results: arrayOf(isAppSettingsCustomEventsDataObject),
});
